import React, { useEffect } from 'react';
import { create, InstanceProps } from 'react-modal-promise';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';

import { Image } from 'components';
import Modal from 'components/Modal';
import { ButtonV3 } from 'components/ComponentV2';
import { PAGE_ROUTES } from 'lib/page-routes';
import { useCommonList } from 'lib/contexts/common-list-context';

import styles from './OnboardingPopupModal.module.scss';

const ModalInstance: React.FC<InstanceProps<Headers>> = ({
  isOpen,
  onResolve,
  onReject,
}) => {
  const router = useRouter();
  const [t] = useTranslation('candidate-dashboard');
  const {
    configData: { jobs_count },
    isConfigDataLoading,
  } = useCommonList();

  useEffect(() => {
    if (
      ![PAGE_ROUTES.CANDIDATE_DASHBOARD, PAGE_ROUTES.CANDIDATE_MATCH].includes(
        router.pathname
      )
    )
      onResolve();
  }, [router.pathname]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onReject}
      className={styles.modal}
      contentClassName={styles.container}
      closeOnOverlayClick={false}
      closeOnESCPress={false}
    >
      <p className={styles.title}>{t('onboarding-popup.title')}</p>
      <Image src={'/images/onboarding-popup.png'} className={styles.image} />
      {!isConfigDataLoading ? (
        <p className={styles.desc}>
          {t('onboarding-popup.desc', { jobs_count })}
        </p>
      ) : null}
      <ButtonV3
        onClick={() => {
          router.push(PAGE_ROUTES.CANDIDATE_ONBOARDING);
          onResolve();
        }}
        isFullWidth
        size="large"
      >
        {t('onboarding-popup.button')}
      </ButtonV3>
    </Modal>
  );
};

export const onboardingPopupModalInstance = create(ModalInstance);
